import styled from "styled-components";
import { CurrentArenaTitleDefaultBox } from "./current-arena-title.default.box";

export const CurrentArenaTitleSICisBox = styled(CurrentArenaTitleDefaultBox)`
    color: ${props => props.theme.colors.brandPrimaryContrast};
    ${({theme}) => theme.font.presets.regular};
    font-weight: 400;
    letter-spacing: 0.6px;
    margin: 5px 0;
    font-size: 15px;    
`;